// import React, { useState } from 'react';
// import axios from 'axios';
// import './index.css';

// const Predict = () => {
//   const [file, setFile] = useState(null);
//   const [experience, setExperience] = useState(0);
//   const [projects, setProjects] = useState(0);
//   const [salary, setSalary] = useState(0);
//   const [chance, setChance] = useState(null);
//   const [error, setError] = useState(null);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const formData = new FormData();
//     formData.append('resume', file);
//     formData.append('experience_years', experience);
//     formData.append('projects_count', projects);
//     formData.append('salary_expectation', salary);
//     try {
//       const res = await axios.post('http://localhost:5000/predict', formData);
//       setChance(res.data.chance);
//       setError(null);
//     } catch (err) {
//       setError('Failed to predict selection chance. Please try again.');
//       console.error(err);
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit}>
//       <div>
//         <label>Upload Resume (PDF)</label>
//         <input
//           type="file"
//           accept=".pdf"
//           onChange={(e) => setFile(e.target.files[0])}
//           required
//         />
//       </div>
//       <div>
//         <label>Experience (Years)</label>
//         <input
//           type="number"
//           style={{color: "black"}}
//           value={experience}
//           onChange={(e) => setExperience(e.target.value)}
//           placeholder="Enter years of experience"
//           required
//         />
//       </div>
//       <div>
//         <label>Number of Projects</label>
//         <input
//           type="number"
//           style={{color: "black"}}
//           value={projects}
//           onChange={(e) => setProjects(e.target.value)}
//           placeholder="Enter number of projects"
//           required
//         />
//       </div>
//       <div>
//         <label>Salary Expectation ($)</label>
//         <input
//           type="number"
//           style={{color: "black"}}
//           value={salary}
//           onChange={(e) => setSalary(e.target.value)}
//           placeholder="Enter salary expectation"
//           required
//         />
//       </div>
//       <button type="submit" className="button-primary">
//         Predict Chances
//       </button>
//       {error && (
//         <div className="alert alert-error">
//           {error}
//         </div>
//       )}
//       {chance && (
//         <div className="alert alert-success">
//           Your selection chance: {chance.toFixed(2)}%
//         </div>
//       )}
//     </form>
//   );
// };

// export default Predict;

import React, { useState } from 'react';
import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const Predict = () => {
  const [file, setFile] = useState(null);
  const [experienceYears, setExperienceYears] = useState('');
  const [jobDescription, setJobDescription] = useState('');
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleAnalyze = async () => {
    if (!file || !experienceYears) {
      alert('Please upload a resume and enter experience years.');
      return;
    }

    setLoading(true);
    setError(null);
    setResults({});

    const formData = new FormData();
    formData.append('resume', file);
    formData.append('experience_years', experienceYears);
    formData.append('job_description', jobDescription);

    try {
      const requests = [
        { url: '/api/ats-score', key: 'atsScore' },
        { url: '/api/improvement-tips', key: 'improvementTips' },
        { url: '/api/role-alignment', key: 'roleAlignment' },
        { url: '/api/skill-gap', key: 'skillGap' },
        { url: '/api/recommend-companies', key: 'recommendedCompanies' },
      ];

      const newResults = {};
      
      for (const req of requests) {
        try {
          const response = await axios.post(`${backendUrl}${req.url}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });

          console.log(`Response for ${req.key}:`, response.data);
          
          // Store the response data directly without modification
          newResults[req.key] = response.data;
          
        } catch (err) {
          console.error(`Error fetching ${req.key}:`, err.response?.data || err.message);
          // Store error info instead of crashing
          newResults[req.key] = { error: err.response?.data?.error || err.message };
        }
      }

      console.log('Final results:', newResults);
      setResults(newResults);
      
    } catch (error) {
      console.error('Error analyzing resume:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h2>Resume Analysis</h2>
      
      <div style={{ marginBottom: '15px' }}>
        <label style={{ display: 'block', marginBottom: '5px' }}>Resume (PDF):</label>
        <input 
          type="file" 
          accept=".pdf"
          onChange={(e) => setFile(e.target.files[0])} 
        />
      </div>

      <div style={{ marginBottom: '15px' }}>
        <label style={{ display: 'block', marginBottom: '5px' }}>Experience Years:</label>
        <input
          type="number"
          value={experienceYears}
          onChange={(e) => setExperienceYears(e.target.value)}
          placeholder="e.g., 3"
          style={{ width: '100%', padding: '8px', color: "black" }}
        />
      </div>

      <div style={{ marginBottom: '15px' }}>
        <label style={{ display: 'block', marginBottom: '5px' }}>Job Description (Optional):</label>
        <textarea
          value={jobDescription}
          onChange={(e) => setJobDescription(e.target.value)}
          placeholder="Paste job description here..."
          rows="4"
          style={{ width: '100%', padding: '8px' }}
        />
      </div>

      <button 
        onClick={handleAnalyze} 
        disabled={loading}
        style={{ 
          padding: '10px 20px', 
          backgroundColor: loading ? '#ccc' : '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: loading ? 'not-allowed' : 'pointer'
        }}
      >
        {loading ? 'Analyzing...' : 'Analyze Resume'}
      </button>

      {loading && <p style={{ marginTop: '15px', color: '#007bff' }}>Processing your resume...</p>}
      {error && <p style={{ marginTop: '15px', color: 'red' }}>Error: {error}</p>}

      {/* Results Display */}
      <div style={{ marginTop: '30px' }}>
        {/* ATS Score */}
        {results.atsScore && !results.atsScore.error && (
          <div style={{ marginBottom: '20px', padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
            <h3>ATS Score: {results.atsScore.score}/100</h3>
            <p><strong>Reasoning:</strong> {results.atsScore.reasoning}</p>
            {results.atsScore.improvement_tips && results.atsScore.improvement_tips.length > 0 && (
              <div>
                <strong>Improvement Tips:</strong>
                <ul>
                  {results.atsScore.improvement_tips.map((tip, i) => (
                    <li key={i}>
                      <strong>[{tip.priority}]</strong> {tip.tip}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}

        {/* Additional Improvement Tips */}
        {results.improvementTips && !results.improvementTips.error && results.improvementTips.tips && (
          <div style={{ marginBottom: '20px', padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
            <h3>Additional Improvement Tips</h3>
            <ul>
              {results.improvementTips.tips.map((tip, i) => (
                <li key={i}>
                  <strong>{tip.category} [{tip.priority}]:</strong> {tip.tip}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Role Alignment */}
        {results.roleAlignment && !results.roleAlignment.error && (
          <div style={{ marginBottom: '20px', padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
            <h3>Role Alignment: {results.roleAlignment.similarity_percentage}%</h3>
            {results.roleAlignment.missing_keywords && results.roleAlignment.missing_keywords.length > 0 && (
              <p><strong>Missing Keywords:</strong> {results.roleAlignment.missing_keywords.join(', ')}</p>
            )}
            {results.roleAlignment.strengths && results.roleAlignment.strengths.length > 0 && (
              <p><strong>Strengths:</strong> {results.roleAlignment.strengths.join(', ')}</p>
            )}
          </div>
        )}

        {/* Skill Gap */}
        {results.skillGap && !results.skillGap.error && (
          <div style={{ marginBottom: '20px', padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
            <h3>Skill Gap Analysis</h3>
            {results.skillGap.user_skills && results.skillGap.user_skills.length > 0 && (
              <p><strong>Your Skills:</strong> {results.skillGap.user_skills.join(', ')}</p>
            )}
            {results.skillGap.missing_skills && results.skillGap.missing_skills.length > 0 && (
              <p><strong>Missing Skills:</strong> {results.skillGap.missing_skills.join(', ')}</p>
            )}
            {results.skillGap.recommendation && (
              <p><strong>Recommendation:</strong> {results.skillGap.recommendation}</p>
            )}
          </div>
        )}

        {/* Recommended Companies */}
        {results.recommendedCompanies && !results.recommendedCompanies.error && results.recommendedCompanies.companies && (
          <div style={{ marginBottom: '20px', padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
            <h3>Recommended Companies</h3>
            <ul>
              {results.recommendedCompanies.companies.map((company, i) => (
                <li key={i}>
                  <strong>{company.name}:</strong> {company.reason}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default Predict;
